export default "__VITE_ASSET__DVuaeCpY__"